import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

class RenameInterview {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly name: string,
	) {
		Object.freeze(this);
	}

	// Route identifiers are never echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
		};
	}
}

export default RenameInterview;
